var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoticeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1",
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64,128a10.18,10.18,0,0,1-7.22-3h0L3,71.22A10.21,10.21,0,0,1,3,56.78L56.78,3A10.22,10.22,0,0,1,71.22,3L125,56.78a10.21,10.21,0,0,1,0,14.44L71.22,125A10.18,10.18,0,0,1,64,128Zm-4.39-5.82a6.2,6.2,0,0,0,8.78,0l53.79-53.79a6.2,6.2,0,0,0,0-8.78L68.39,5.82a6.2,6.2,0,0,0-8.78,0L5.82,59.61a6.2,6.2,0,0,0,0,8.78l53.79,53.79Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64,82a8.24,8.24,0,0,1-8.25-7.91L54.27,38.6A8.25,8.25,0,0,1,62.52,30h3a8.25,8.25,0,0,1,8.25,8.6L72.25,74.09A8.24,8.24,0,0,1,64,82ZM62.52,34a4.25,4.25,0,0,0-4.25,4.43l1.48,35.49a4.25,4.25,0,0,0,8.5,0l1.48-35.49A4.25,4.25,0,0,0,65.48,34Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64,102a8,8,0,1,1,8-8A8,8,0,0,1,64,102Zm0-12a4,4,0,1,0,4,4A4,4,0,0,0,64,90Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoticeIcon);
export default __webpack_public_path__ + "static/media/notice_icon.85a3d0430468ccc66f8192f5479a20a8.svg";
export { ForwardRef as ReactComponent };